import { API } from '~/config';

type ApiCallConfig = RequestInit;

export const apiCall = async (config: ApiCallConfig = {}): Promise<Response> => {
    const url = `${API.URL}/register?pl=${new URLSearchParams(window.location.search).get('pl')}`;
    const response = await fetch(url, {
        credentials: 'omit',
        method: 'POST',
        ...config,
    });
    if (!response.ok) {
        const errorBody = await response.text();
        const errorDetails = {
            body: errorBody,
            status: response.status,
            statusText: response.statusText,
        };
        const error = new Error(`API request failed: ${errorDetails.status} - ${errorDetails.statusText}`);
        (error as any).cause = errorBody;
        throw error;
    }
    return response;
};
